/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useWindowSize } from '@brands/hooks';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import React, { FC, useMemo } from 'react';
import Modal, { Styles } from 'react-modal';

import closeICon from '../../Patient/components/closeIconSVG.svg';
import styles from './styles.module.scss';

interface EndCallWarningModalProps {
  isOpen: boolean;
  toggleModal: (value: boolean) => void;
  endCallNow: () => void;
}

const mobileCustomStylesDashboard: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...(customStylesDashboard?.overlay || {}),
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    overflowY: 'scroll' as const,
    overflowX: 'hidden' as const,
  },
  content: {
    ...(customStylesDashboard?.content || {}),
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '320px',
    height: 'auto',
    padding: '90px 16px 32px 16px',
    margin: '0',
    borderRadius: '0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
};

const customStylesDashboardDesktop: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...customStylesDashboard.overlay,
  },
  content: {
    ...customStylesDashboard.content,
    flexDirection: 'column',
    width: '444px',
    padding: '55px 32px 32px',
    overflowY: 'auto',
    maxHeight: '850px',
    justifyContent: 'flex-start',
    backgroundColor: '#fff',
  },
};

const EndCallWarningModal: FC<EndCallWarningModalProps> = ({ isOpen, toggleModal, endCallNow }) => {
  const screenSize = useWindowSize();
  const isMobile = useMemo(() => screenSize.width < 768, [screenSize.width]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => toggleModal(false)}
      style={isMobile ? mobileCustomStylesDashboard : customStylesDashboardDesktop}
      contentLabel="End Call Warning Modal"
      ariaHideApp={false}
    >
      <div className={styles.closeICon}>
        <img src={closeICon} onClick={() => toggleModal(false)} />
      </div>
      <div className={styles.removeItemContainer}>
        <h2 className={styles.removeModalHeader}>Ending the call now may affect your payment</h2>
        <p className={styles.removeModalSubtile}>
          If your patient doesn’t show, you’ll need to stay on the call for at least 10 minutes after the appointment
          start time to receive payment. Are you sure you want to end the call?
        </p>
        <div>
          <button
            className={styles.primaryButton}
            onClick={() => {
              toggleModal(false);
              endCallNow();
            }}
          >
            Yes, End Call
          </button>

          <button
            className={styles.cancel}
            onClick={() => {
              toggleModal(false);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

Modal.setAppElement('#root');

export default EndCallWarningModal;
